<template>
    <b-modal id="modalAtualizarDataVencimento" @ok="atualizarDataVencimento" 
        @cancel="fatura=null;dataVencimento=null" title="Alterar data de vencimento"
      size="xl" ok-title="Confirmar" cancel-title="Cancelar">
        <datepicker v-model="dataVencimento" :disabled-dates="disabledDates" :format="formataDataBoleto" :language="ptBR" calendar-button-icon="fa fa-calendar-alt" clear-button bootstrap-styling calendar-button></datepicker>
    </b-modal>
</template>
<script>
import datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'
import moment from 'moment';
import axios from 'axios';

export default {
    props: {
        pedido: {
            type: Object,
            required: true
        },
        fatura: {
            type: Object,
            required: true
        }
    },
    components: {
        datepicker
    },
    data() {
      return {
        ptBR: ptBR,
        disabledDates: {
            days: [6, 0],
            to: new Date()
        },
        dataVencimento: null,
      }
    },
    methods: {
     formataDataBoleto(data) {
      if (!data) return '';
       return moment(data).format("DD/MM/YYYY");
      },
      getCharge(charges) {
        if (!charges) {
          return {}
        }
        if (charges.length == 1) {
          return charges[0];
        }

        return charges.find(charge => charge.status === 'pending' || charge.status === 'paid')
      },
      async atualizarDataVencimento(bvModalEvt) {
        bvModalEvt.preventDefault()
        this.$store.dispatch('setLoading', true);
        try {
          await axios.post(`/api/saude/novaDataPagamentoFatura?idEmpresa=${this.pedido.juridica._id}`,{
            novaDataVencimento: this.dataVencimento,
            idCobranca: this.getCharge(this.fatura.charges).id
          });
          this.$bvModal.hide('modalAtualizarDataVencimento');

          const responseTransacoes = await axios.get(`/api/saude/faturaAvulsa?idPedido=${this.pedido._id}`);
          this.transacoes = responseTransacoes.data;

        } catch (error) {
          // eslint-disable-next-line
          console.log(error);
        } finally {
          this.dataVencimento = null;
          this.$store.dispatch('setLoading', false);
        }
      },
    }

}
</script>